import 'react-datepicker/dist/react-datepicker.css';

import { FormControl, Input, Textarea, FormLabel, FormHelperText } from '@chakra-ui/react';

import { DateTimeInputIcon } from 'components/Icons/Icons';

const CustomField = ({ 
  id, 
  label, 
  type = 'text', 
  value, 
  isValid, 
  onChange, 
  placeholder = '',
  mt,
  mb,
  display,
  ...restProps
}) => {
  return (
    <FormControl variant="floating" id={id} mt={mt} mb={mb} display={display}>
      {type === 'textarea' ? (
        <Textarea
          value={value}
          resize="none"
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          h={{ base: '226.5px !important' }}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      ) : (
        <Input
          value={value}
          type={type}
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      )}
      <FormLabel
        htmlFor={id}
        className={isValid ? 'input-valid' : 'input-invalid'}
      >
        {label}
      </FormLabel>
      <FormHelperText
        className={isValid ? 'hidden' : 'input-error'}
      >
        Input invalid
      </FormHelperText>

      { type === 'datetime-local' && (
        <DateTimeInputIcon 
          fontSize="24px"
          position="absolute"
          right="15px"
          top="15px"
          color="#9FABCB"
          pointerEvents="none"
          zIndex="1"
        />
      )}

    </FormControl>
  );
};

export default CustomField;